import React from 'react';
export function Testimonials() {
  const testimonials = [{
    before: 'En 21 días ',
    highlight: 'bajé 3 kilos sin privarme de nada',
    after: '. Sigo comiendo alfajores.',
    author: 'Mariana G., 34',
    location: 'Buenos Aires'
  }, {
    before: 'El helado de chocolate proteico lo hago todas las semanas. ',
    highlight: 'Mi familia no nota que es fit',
    after: '.',
    author: 'Carolina P., 41',
    location: 'Córdoba'
  }, {
    before: 'Entendí por qué me daba el pico de las 4pm. ',
    highlight: 'Ya no me da',
    after: '.',
    author: 'Valentina R., 29',
    location: 'Rosario'
  }, {
    before: 'El Kit 11:11 ',
    highlight: 'me salvó tres veces esta semana',
    after: '.',
    author: 'Florencia M., 47',
    location: 'Mendoza'
  }, {
    before: 'La chocotorta fit ',
    highlight: 'quedó igual que la original',
    after: '. Mi marido la pide todos los fines de semana.',
    author: 'Luciana B., 38',
    location: 'La Plata'
  }];
  return <section className="bg-chocolate-50 py-20 px-4" data-id="element-247">
      <div className="max-w-6xl mx-auto" data-id="element-248">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-chocolate-900 mb-12" data-id="element-249">
          Historias Reales
        </h2>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-250">
          {testimonials.map((t, idx) => <div key={idx} className="break-inside-avoid bg-white p-6 rounded-2xl shadow-sm border border-chocolate-800/5" data-id="element-251">
              <div className="text-gold-400 text-lg mb-4" data-id="element-252">⭐⭐⭐⭐⭐</div>
              <p className="text-chocolate-800 text-lg italic mb-6" data-id="element-253">
                "{t.before}
                <span className="font-bold not-italic text-solution bg-solution/15 px-1 rounded" data-id="element-254">
                  {t.highlight}
                </span>
                {t.after}"
              </p>
              <div className="flex items-center gap-3" data-id="element-255">
                <div className="w-10 h-10 rounded-full bg-chocolate-100 flex items-center justify-center text-chocolate-900 font-bold" data-id="element-256">
                  {t.author.charAt(0)}
                </div>
                <div data-id="element-257">
                  <p className="font-bold text-chocolate-900" data-id="element-258">{t.author}</p>
                  <p className="text-sm text-chocolate-800/70" data-id="element-259">
                    | {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}